import { Framework } from '@mutopad/connex-framework';
import { genesisBlocks } from './config';
import { compat1 } from './compat';
import { createFull, DriverVendorOnly } from './driver';
import { newVendor } from '@mutopad/connex-framework';
/** convert options.network to Connex.Thor.Block */
function normalizeNetwork(n) {
    n = n || 'main';
    if (typeof n === 'string') {
        const gb = genesisBlocks[n];
        if (!gb) {
            throw new Error('invalid network');
        }
        return gb;
    }
    else {
        return n;
    }
}
/** convert network name to genesis id */
function normalizeGenesisId(id) {
    id = id || 'main';
    if (/^0x[0-9a-f]{64}$/.test(id)) {
        return id;
    }
    const gb = genesisBlocks[id];
    if (gb) {
        return gb.id;
    }
    throw new Error('invalid genesis id');
}
/** Vendor class which can work standalone to provides signing-services only */
class VendorClass {
    constructor(genesisId, opts) {
        genesisId = normalizeGenesisId(genesisId);
        if (!(opts && opts.noV1Compat)) {
            try {
                // to detect injected connex
                const injected = window.connex;
                if (injected && injected.thor.genesis.id === genesisId) {
                    // injected genesis id matched
                    if (/^1\./.test(injected.version)) {
                        // wrap v1 vendor to v2
                        return compat1(injected).vendor;
                    }
                }
            }
            catch ( /**/_a) { /**/ }
        }
        // detect the extension injected vechain
        const useExtension = !(opts && opts.noExtension) && !!window.vechain && !opts.mutopadId;
        const driver = new DriverVendorOnly(genesisId, useExtension);
        const vendor = newVendor(driver);
        return {
            get sign() {
                return vendor.sign.bind(vendor);
            }
        };
    }
}
/** Connex class */
class ConnexClass {
    constructor(opts) {
        console.log("Options passsed by constructor: ", opts);
        const genesis = normalizeNetwork(opts.network);
        // const extPromise = await getExtId()
        if (!opts.noV1Compat) {
            try {
                // to detect injected connex
                const injected = window.connex;
                if (injected && injected.thor.genesis.id === genesis.id) {
                    // injected genesis id matched
                    if (/^1\./.test(injected.version)) {
                        // wrap v1 to v2
                        return compat1(injected);
                    }
                }
            }
            catch ( /**/_a) { /**/ }
        }
        console.log("Check if current extetnion supports mutopad", window.mutopad);
        // detect the extension injected vechain
        const useExtension = !opts.noExtension && !opts.mutopadId;
        console.log("Extension ID for mutopad:", opts, "useExtension", useExtension);
        const driver = createFull(opts.node, genesis, useExtension, opts.mutopadId);
        const currentId = opts.mutopadId;
        const framework = new Framework(driver);
        return {
            get thor() { return framework.thor; },
            get vendor() { return framework.vendor; },
            get mutopad() { return currentId; },
        };
    }
}
ConnexClass.Vendor = VendorClass;
export default ConnexClass;
export { ConnexClass as Connex };
//# sourceMappingURL=data:application/json;base64,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